export const CartOutlinedIcon: React.FC<React.SVGAttributes<{}>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.6 19.6" {...props}>
    <path
      data-name="Path 12"
      d="M12.8 8.8v-4a4 4 0 00-8 0v4m-3-2h14l1 12H.8z"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.6"
    />
  </svg>
);
